<div class="fee-form-wrapper">
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()" class="h-100">
    <div class="table-container" #tableContainer>
      <ng-container formArrayName="fees">
        <table class="fee-table table table-bordered">
          <thead>
            <tr>
              <th>Applicable</th>
              <th>Fee</th>
              <th>Amount</th>
              <th>Payable</th>
              <th>Can add fee to loan?</th>
              <th>Lending Type</th>
              <th>Mortgage Type</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let fee of feeArray.controls; let i = index" [formGroupName]="i">
              <tr>
                <!-- 1. Applicable -->
                <td [class.inactive-cell]="isDisabled(fee, 'applicable') && !disabled">
                  <input
                    type="checkbox"
                    formControlName="applicable"
                    class="big-checkbox"
                    [attr.data-testid]="'fee_applicable_checkbox_' + i"
                  />
                </td>
                <!-- 2. Fee and Tooltip -->
                <td [class.inactive-cell]="isDisabled(fee, 'amount') && !disabled">
                  <span class="form-text">{{ fee.value.name }}</span>
                  <i [ngbTooltip]="getFeeTooltip(fee.value.name)" class="fas fa-info-circle tracker-info ms-1"></i>
                </td>
                <!-- 3. Amount -->
                <td [class.inactive-cell]="isDisabled(fee, 'amount') && !disabled" class="mw-120">
                  @if (fee.value.constant) {
                  } @else if (isDisabled(fee,'amount') && (!disabled || !fee.value.amount )) {
                    <input
                      type="text"
                      formControlName="amount"
                      placeholder=""
                      class="form-control"
                      [attr.data-testid]="'fee_amount_input_' + i"
                    />
                  } @else {
                    <div
                        class="input-group"
                        [class.is-invalid]="getFeeControl(i,'amount').invalid && getFeeControl(i,'amount').touched"
                        [class.inactive]="disabled">
                        <span class="input-group-text">£</span>
                        <input
                          type="text"
                          formControlName="amount"
                          placeholder="0.00"
                          appTwoDigitDecimalNumber
                          class="form-control"
                          [attr.data-testid]="'fee_amount_input_' + i"
                        />
                      </div>
                      <div *ngIf="!isDisabled(fee,'amount') && getFeeControl(i,'amount').touched">
                        <div *ngIf="getFeeControl(i,'amount').hasError('required')" class="text-danger text-error mt-2">
                          Fee amount is required.
                        </div>
                        <div *ngIf="getFeeControl(i,'amount').hasError('min')" class="text-danger text-error mt-2">
                          Fee amount must be greater than 0.
                        </div>
                        <div *ngIf="getFeeControl(i,'amount').hasError('max')" class="text-danger text-error mt-2">
                          Fee amount must be less than £100,000.
                        </div>
                      </div>
                  }
                </td>
                <!-- 4. Payable -->
                <td [class.inactive-cell]="isDisabled(fee, 'whenPayable') && !disabled">
                  @if (fee.value.whenPayableIsConstant) {
                    <span class="form-text">{{ getFeeControl(i,'whenPayable')?.value }}</span>
                  } @else if (!fee.value.applicable && !fee.value.constant){
                    <select
                      class="form-select"
                      [attr.data-testid]="'fee_payable_select_' + i"
                      [disabled]="isDisabled(fee, 'whenPayable')"
                    >
                    </select>
                  } @else {
                    <select
                      formControlName="whenPayable"
                      class="form-select"
                      [attr.data-testid]="'fee_payable_select_' + i"
                    >
                      <option *ngFor="let option of model.supportedPayable" [value]="option">
                        {{ option }}
                      </option>
                    </select>
                  }
                </td>
                <!-- 5. Can add fee to loan? -->
                <td [class.inactive-cell]="isDisabled(fee, 'addToLoan') && !disabled">
                  <input
                    type="checkbox"
                    formControlName="addToLoan"
                    class="big-checkbox"
                    [attr.data-testid]="'fee_canAdd_checkbox_' + i"
                  />
                </td>
                <!-- 6. Lending Type -->
                <td [class.inactive-cell]="isDisabled(fee, 'lendingType') && !disabled">
                  @if (fee.value.constant) {
                  } @else if (lendingTypeOptions.length === 1) {
                    <span class="form-text">{{ getFeeControl(i,'lendingType')?.value }}</span>
                  } @else if (!fee.value.applicable) {
                    <select
                      class="form-select"
                      [attr.data-testid]="'fee_lendingType_select_' + i"
                      [disabled]="isDisabled(fee, 'lendingType')"
                    >
                    </select>
                  }  @else {
                    <select
                      formControlName="lendingType"
                      class="form-select"
                      [attr.data-testid]="'fee_lendingType_select_' + i"
                    >
                      <option *ngFor="let option of lendingTypeOptions" [value]="option">
                        {{ option }}
                      </option>
                    </select>
                  }
                </td>
                <!-- 7. Mortgage Type -->
                <td [class.inactive-cell]="isDisabled(fee, 'feeConfiguration') && !disabled" class="mortgage-type-col">
                  <div class="mortgage-type-container">
                    @if (fee.value.constant) {
                    } @else if (!isDisabled(fee, 'feeConfiguration') || disabled) {
                      <lib-select
                        formControlName="feeConfiguration"
                        class="mortgage-type-select"
                        [options]="feeConfigOptions"
                        [multi]="true"
                        [chips]="true"
                        [attr.data-testid]="'fee_mortgageType_select_' + i"
                        [class.is-invalid]="hasConfigError(i)"
                    />
                    } @else {
                      <lib-select
                          class="mortgage-type-select"
                          [options]="[]"
                          [multi]="true"
                          [chips]="true"
                          [attr.data-testid]="'fee_mortgageType_select_' + i"
                          [disabled]="isDisabled(fee, 'feeConfiguration')"
                      />
                    }
                    <button
                      *ngIf="canRemoveFee(i)"
                      type="button"
                      (click)="removeAdditionalLine(i)"
                      class="trash-btn btn btn-2022--secondary"
                      [attr.data-testid]="'fee_remove_additional_btn_' + i"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                  <div *ngIf="hasConfigError(i)">
                    <div
                      *ngIf="fee.hasError('requiredMortgageType') && getFeeControl(i,'feeConfiguration').touched"
                      class="text-danger mt-2">
                      Please select at least one Mortgage Type.
                    </div>
                    <div *ngIf="fee.hasError('duplicateConfiguration')" class="text-danger mt-2">
                      Mortgage Type overlapping between several fees.
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
    </div>

    <div *ngIf="!disabled" class="footer-buttons">
      <div class="additional-fee-dropdown-container">
        <select
          id="addAdditionalFee"
          (change)="onAdditionalFeeSelected($event.target.value); $event.target.value=''"
          class="additional-fee-dropdown form-select btn btn-2022--secondary"
          [attr.data-testid]="'add_additional_fee_select'"
        >
          <option disabled selected hidden value="">Add Additional Fee</option>
          <option *ngFor="let feeName of additionalFeeOptions" [value]="feeName">
            {{ feeName }}
          </option>
        </select>
      </div>
      <div class="submit-button">
        <button
          type="submit"
          [disabled]="form.pristine"
          class="btn btn-2022--secondary"
          [attr.data-testid]="'fee_submit_btn'"
        >
          Submit
        </button>
      </div>
    </div>
    <div *ngIf="disabled" class="mt-2">
      <span class="form-text">Fee configuration is currently Read Only, to request a change please contact lgmstechsupport&#64;landg.com</span>
    </div>
  </form>
</div>

<ng-template #lendingTypeModalTemplateRef>
  <p>
      The following action will create a separate fee for Residential and Buy to Let products. Ok to proced?
  </p>
  <div class="text-end">
      <a class="btn btn-2022--secondary me-2" (click)="duplicateFee(); modalService.close()">
          OK
      </a>
      <a class="btn btn-2022--secondary me-2" (click)="modalService.close();">
          Not Required
      </a>
      <a class="btn btn-2022--secondary" (click)="setDefaultLendingType(); modalService.close();">
          Cancel
      </a>
  </div>
</ng-template>

